import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVRCLIWithCustprofile} from '../containers'
function CruiseWithCustprofilePage() {
    let { id} = useParams();
    let svparams = { 'id': id}
    return (
        <SVRCLIWithCustprofile svparams= {svparams} />
       
        
       
    );
}
export default CruiseWithCustprofilePage